<template>
  <div class="row spinning-wheel-campaigns-page">
    <div class="col-md-12 col-lg-12">
      <div class="search-bar">
        <div class="col-sm-12 no-padding">
          <div class="pull-left">
            <el-input v-model="filters[0].value" :placeholder="$t('reports.search')" class="icon-search"></el-input>
          </div>
          <div class="pull-right">
            <router-link
              class="btn add"
              :title="$t('general.add') + ' ' + $t('pages.spinningWheelCampaigns')"
              :to="{ path: '/marketing/spinning-wheel-campaigns/add' }"
            >
              <img src="/static/img/icons/add.png">
              {{ $t('general.add') }}
            </router-link>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-content row">
          <data-tables
            ref="spinningWheelDataTables"
            class="width-table spinning-wheel-campaigns-table"
            v-loading="loading"
            :data="tableData"
            :action-def="defaultActionDef()"
            :pagination-def="paginationDef"
            :table-props="{ border: false }"
            :filters="filters"
            @row-click="goToRecord"
            style="width: 100%"
          >
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="70"
              prop="id"
              :label="$t('customers.id')"
            />
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="160"
              prop="title"
              :label="$t('spinningWheel.campaignTitle')"
            />
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="180"
              :label="$t('spinningWheel.availability')"
            >
              <template slot-scope="props">
                {{ formatAvailabilityRange(props.row) }}
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="120"
              :label="$t('spinningWheel.minOrderValue')"
            >
              <template slot-scope="props">
                {{ props.row.minimum_order_value != null ? props.row.minimum_order_value : '—' }}
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="100"
              :label="$t('spinningWheel.rewardsCount')"
            >
              <template slot-scope="props">
                {{ props.row.rewards_count != null ? props.row.rewards_count : (props.row.rewards ? props.row.rewards.length : 0) }}
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="110"
              :label="$t('spinningWheel.percentages')"
            >
              <template slot-scope="props">
                <span :class="props.row.percentages_valid ? 'text-success' : 'text-danger'">
                  {{ formatPercentage(props.row.percentage_sum) }}%
                </span>
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :min-width="90"
              :label="$t('spinningWheel.active')"
            >
              <template slot-scope="props">
                <p-switch
                  :value="!!props.row.active"
                  type="success"
                  @input="(val) => handleActive(props.row, val)"
                />
              </template>
            </el-table-column>
            <el-table-column
              class-name="centered-cell"
              align="center"
              header-align="center"
              :width="120"
              prop="actions"
              :label="$t('marketingCampaigns.actions')"
            >
              <template slot-scope="props">
                <el-dropdown trigger="click" placement="bottom-end" @click.native.stop>
                  <span class="arrow-box">&#9662;</span>
                  <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item @click.native.stop="editRecord(props.row)">
                      {{ $t('general.edit') }}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native.stop="handleDelete(props.row)">
                      {{ $t('general.delete') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import DataTables from 'vue-data-tables'
import swal from 'sweetalert2'
import PSwitch from 'src/components/UIComponents/Switch.vue'

Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(DataTables)

export default {
  components: { PSwitch },
  props: {
    isSpinningWheelCampaigns: { type: Boolean, default: false }
  },
  watch: {
    isSpinningWheelCampaigns (v) {
      if (v) this.initPage()
    },
    tableData () {
      this.$nextTick(() => this.layoutTable())
    }
  },
  data () {
    return {
      loading: false,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      filters: [{ value: '', prop: ['title', 'id'] }],
      tableData: []
    }
  },
  created () {
    this.$bus.$on('refresh', this.handleRefresh)
  },
  mounted () {
    this.initPage()
    this._onResizeTable = () => this.layoutTable()
    window.addEventListener('resize', this._onResizeTable)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
    if (this._onResizeTable) {
      window.removeEventListener('resize', this._onResizeTable)
    }
  },
  methods: {
    handleRefresh () {
      this.initPage()
    },
    layoutTable () {
      const dt = this.$refs.spinningWheelDataTables
      const elTable = dt && dt.$refs && dt.$refs.elTable
      if (elTable && typeof elTable.doLayout === 'function') {
        elTable.doLayout()
      }
    },
    goToRecord (row, column) {
      if (column && column.property === 'actions') return
      this.editRecord(row)
    },
    editRecord (row) {
      if (!row || !row.id) return
      this.$router.push('/marketing/spinning-wheel-campaigns/edit/' + row.id)
    },
    formatAvailabilityRange (row) {
      const dash = this.$t('general.emDash') || '—'
      const from = row.starts_at || null
      const to = row.ends_at || null
      if (!from && !to) return dash
      const formatSafe = (value) => {
        if (!value) return null
        const formatted = this.formatDate(value)
        if (!formatted || formatted === 'Invalid date') return null
        return formatted
      }
      const a = formatSafe(from)
      const b = formatSafe(to)
      if (!a && !b) return dash
      return `${a || dash} - ${b || dash}`
    },
    formatPercentage (value) {
      if (value == null || value === '') return '0'
      const n = Number(value)
      if (Number.isNaN(n)) {
        const s = String(value)
        return s.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '') || '0'
      }
      const fixed = n.toFixed(4)
      return fixed.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
    },
    normalizeList (response) {
      if (!response || !response.data) return []
      const d = response.data
      if (Array.isArray(d)) return d
      if (Array.isArray(d.data)) return d.data
      return []
    },
    initPage () {
      this.loading = true
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/spinning-wheel-campaigns', 'GET', data, (response) => {
        if (response.status) {
          this.tableData = this.normalizeList(response)
        } else {
          swal('', this.$t('validations.wentWrong'), 'error')
        }
        this.loading = false
        this.$nextTick(() => this.layoutTable())
      })
    },
    handleActive (row, val) {
      const previous = !!row.active
      row.active = val
      const body = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: val ? 1 : 0
      }
      this.apiRequest('/spinning-wheel-campaigns/' + row.id, 'PUT', body, (response) => {
        if (!response.status) {
          row.active = previous
          const msg = (response.errors && (response.errors.active || response.errors.message)) || this.$t('validations.wentWrong')
          swal('', Array.isArray(msg) ? msg[0] : msg, 'error')
          return
        }
        if (response.data) {
          row.percentages_valid = response.data.percentages_valid
          row.percentage_sum = response.data.percentage_sum
          row.active = !!response.data.active
        }
      })
    },
    handleDelete (row) {
      swal({
        title: this.$t('spinningWheel.confirmDelete'),
        useRejections: false,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then((result) => {
        if (!result || !result.value) return
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/spinning-wheel-campaigns/' + row.id, 'DELETE', data, (response) => {
          if (response.status) {
            this.initPage()
            swal('', this.$t('general.success'), 'success').catch(() => {})
          } else {
            swal('', this.$t('validations.wentWrong'), 'error')
          }
        })
      })
    }
  }
}
</script>

<style>
.spinning-wheel-campaigns-page .el-table .cell {
  height: 55px;
  min-height: 55px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.spinning-wheel-campaigns-page .el-table thead .cell {
  height: initial !important;
  min-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.fixed.sidebar-left .spinning-wheel-campaigns-page table.el-table__body tbody tr.el-table__row {
  margin: 10px 0 !important;
}
.spinning-wheel-campaigns-page .centered-cell .cell {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}
.spinning-wheel-campaigns-page .arrow-box {
  display: inline-block;
  font-size: 18px;
  padding: 4px 6px;
  border: 1px solid #674BD2 !important;
  border-radius: 4px;
  cursor: pointer;
  color: #674BD2;
}
.spinning-wheel-campaigns-page .arrow-box:hover {
  background-color: #674BD2 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/SpinningWheel/SpinningWheelCampaigns.vue